import { render, staticRenderFns } from "./BlacklistReasonCreateModal.vue?vue&type=template&id=1ec06129&"
import script from "./BlacklistReasonCreateModal.vue?vue&type=script&lang=js&"
export * from "./BlacklistReasonCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports